<template>
  <v-card>
    <s-crud
      :config="config"
      title="Planes de Telefonía"
      :filter="filter"
      search-input
      add
      edit
      remove
      @save="save($event)"
      ref="crudPhonePlan"
      nameScrud="crudPhonePlan"
      height="480px"
    >
      <template v-slot="props">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="s-col-form" md="6">
              <s-select-definition
                :def="1691"
                label="Operador"
                v-model="props.item.OperatorID"
                searchable
                :add="$fun.isAdmin()"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="6">
              <s-text
                label="Nombre del Plan"
                v-model="props.item.CppName"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text
                label="Min. Nacionales"
                v-model="props.item.CppNationalMins"
                typeText="number"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text
                label="Min. Internacionales"
                v-model="props.item.CppIntMins"
                typeText="number"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text
                label="Datos Nac. (GB)"
                v-model="props.item.CppNationalData"
                typeText="number"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text
                label="Datos Int. (GB)"
                v-model="props.item.CppIntData"
                typeText="number"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="s-col-form" md="3">
              <v-switch
                label="Roaming"
                v-model="props.item.CppHasRoaming"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text
                label="Cobertura Int."
                v-model="props.item.CppIntCoverage"
                typeText="number"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="6">
              <s-select-definition
                :def="1695"
                label="Zona de Cobertura"
                v-model="props.item.CppCoverageZone"
                @change="onZoneChange(props.item)"
                clearable
                :add="$fun.isAdmin()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <s-textarea
                label="Detalle de Países"
                v-model="props.item.CppCountries"
                rows="2"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="s-col-form" md="4">
              <s-text
                label="Precio"
                v-model="props.item.CppPrice"
                typeText="number"
                prefix="S/ "
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="4">
              <s-text
                label="Descuento (%)"
                v-model="props.item.CppDiscount"
                typeText="number"
                suffix="%"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" md="4">
              <s-text
                label="Total a Pagar"
                :value="totalToPay(props.item)"
                typeText="number"
                prefix="S/ "
                disabled
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.CppNationalMins="{ item }">
        <v-chip v-if="item.CppNationalMins >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip>
        <span v-else>{{ item.CppNationalMins }} Min</span>
      </template>
      <template v-slot:item.CppIntMins="{ item }">
        <v-chip v-if="item.CppIntMins >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip>
        <span v-else>{{ item.CppIntMins }} Min</span>
      </template>
      <template v-slot:item.CppNationalData="{ item }">
        <v-chip v-if="item.CppNationalData >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip>
        <span v-else>{{ item.CppNationalData }} GB</span>
      </template>
      <template v-slot:item.CppIntData="{ item }">
        <v-chip v-if="item.CppIntData >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip>
        <span v-else>{{ item.CppIntData }} GB</span>
      </template>
      <template v-slot:item.CppHasRoaming="{ item }">
        <v-chip v-if="item.CppHasRoaming" x-small color="green" text-color="white">Sí</v-chip>
        <v-chip v-else x-small color="grey" text-color="white">No</v-chip>
      </template>
    </s-crud>
  </v-card>
</template>

<script>
import TicPhonePlanService from "../../../services/InformationTechnology/TicPhonePlanService";

export default {
  data() {
    return {
      filter: {},
      config: {
        service: TicPhonePlanService,
        model: {
          CppID: "ID",
        },
        headers: [
          { text: "ID", value: "CppID", width: 60 },
          { text: "Operador", value: "OperatorName" },
          { text: "Nombre del Plan", value: "CppName" },
          { text: "Min. Nacionales", value: "CppNationalMins", align: "center", width: 100 },
          { text: "Min. Internacionales", value: "CppIntMins", align: "center", width: 100 },
          { text: "Datos Nac. (GB)", value: "CppNationalData", align: "center", width: 100 },
          { text: "Datos Int. (GB)", value: "CppIntData", align: "center", width: 100 },
          { text: "Zona Cobertura", value: "CoverageZoneName", align: "center", width: 100 },
          { text: "Cobertura Int.", value: "CppIntCoverage", align: "center", width: 80 },
          { text: "Roaming", value: "CppHasRoaming", align: "center", width: 80 },
          { text: "Precio", value: "CppPrice", align: "center", width: 80 },
          { text: "Descuento", value: "CppDiscount", align: "center", width: 80 },
          { text: "A Pagar", value: "CppTotalToPay", align: "center", width: 80 },
        ],
      },
    };
  },
  methods: {
    onZoneChange(item) {
      if (item.CppCoverageZone == 1) {
        this.$set(item, 'CppCountries', 'Bolivia, Ecuador, Colombia, Chile, Argentina, Brasil, Costa Rica, El Salvador, Guatemala, Honduras, México, Nicaragua, Panamá, Paraguay, Puerto Rico, República Dominicana y Uruguay');
      } else if (item.CppCoverageZone == 2) {
        this.$set(item, 'CppCountries', 'Bolivia, Ecuador, Colombia, Chile, Argentina, Brasil, Costa Rica, El Salvador, Guatemala, Honduras, México, Nicaragua, Panamá, Paraguay, Puerto Rico, República Dominicana y Uruguay, | EE.UU. y Canadá');
      } else if (item.CppCoverageZone == 3) {
        this.$set(item, 'CppCountries', 'España, Italia, Francia, Alemania, Reino Unido, Holanda, Suiza, Bélgica, Austria, Portugal, Grecia, Suecia, Irlanda, Hungría, Croacia y Rusia');
      } else if (item.CppCoverageZone == 4) {
        this.$set(item, 'CppCountries', 'Bolivia, Ecuador, Colombia, Chile, Argentina, Brasil, Costa Rica, El Salvador, Guatemala, Honduras, México, Nicaragua, Panamá, Paraguay, Puerto Rico, República Dominicana y Uruguay, | España, Italia, Francia, Alemania, Reino Unido, Holanda, Suiza, Bélgica, Austria, Portugal, Grecia, Suecia, Irlanda, Hungría, Croacia y Rusia');
      } else {
        this.$set(item, 'CppCountries', '');
      }
    },
    totalToPay(item) {
      const price = Number(item.CppPrice) || 0;
      const discount = Number(item.CppDiscount) || 0;
      return (price - (price * discount / 100)).toFixed(2);
    },
    save(item) {
      item.UsrCreateID = this.$fun.getUserID();
      const price = Number(item.CppPrice) || 0;
      const discount = Number(item.CppDiscount) || 0;
      item.CppTotalToPay = price - (price * discount / 100);
      item.save();
    },
  },
};
</script>
